import React, { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { FinanceOperationsTable } from 'widgets/financeOperations';

export const FinanceOperationsPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Финансовые операторы'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <FinanceOperationsTable />;
};
